/**
 * Created by jackzdhqq.com on 2017/5/12.
 */
import axios from './axios';
import qs from 'qs';

export default{
  /**
   * 上传头像
   * @param params
   * @returns {Promise.<TResult>}
   */
  passAvator (params) {
    return axios.post('/wedu/v1/sign-in/update-profile', qs.stringify(params))
      .then(
        response => {
          if (response.status !== 200) {
            throw new Error('接口返回错误');
          } else {
            return response.data;
          }
        }
      );
  },
  notice (params) {
    return axios.get('/wedu/v1/notice/index?', {
      params: params
    })
      .then(response => {
        if (response.status !== 200) {
          throw new Error('接口返回错误');
        } else {
          return response.data;
        }
      });
  },
  completeCourse (pageNumber) {
    // {params: params}
    return axios.get(`/api/studentAboveCourse?pageNumber=${pageNumber}`)
      .then(response => {
        if (response.status !== 200) {
          throw new Error('接口返回错误');
        } else {
          return response.data;
        }
      });
  },
  detailCourse (id) {
    return axios.get(`/api/detailedInformation?sigId=${id}`)
      .then(response => {
        if (response.status !== 200) {
          throw new Error('接口返回错误');
        } else {
          return response.data;
        }
      });
  },
  courseAbout (params) {
    return axios.get('/wedu/v1/course-order-item/index', {
      params
    })
      .then(response => {
        if (response.status !== 200) {
          throw new Error('接口返回错误');
        } else {
          console.log(response);
          return response.data;
        }
      });
  },
  photos (page) {
    return axios.get('/wedu/v1/course/my-photos', {
      params: {page: page}
    })
      .then(response => {
        if (response.status !== 200) {
          throw new Error('接口返回错误');
        } else {
          return response.data;
        }
      });
  },
  exit (params) {
    return axios.get('/wedu/v1/sign-in/logout')
      .then(response => {
        if (response.status !== 200) {
          throw new Error('接口返回错误');
        } else {
          return response.data;
        }
      });
  },
  uploadCid(params) {
    return axios.post('/wedu/v1/sign-in/user-profile', qs.stringify(params))
      .then(
        response => {
          if (response.status !== 200) {
            throw new Error('接口返回错误');
          } else {
            return response.data;
          }
        }
      );
  }
};



// WEBPACK FOOTER //
// ./src/api/netTool.js